module.exports = __webpack_public_path__ + "static/img/chanping22.9b61543.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img1/srzq/chanping22.jpg
// module id = 44Oq
// module chunks = 0